import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { HospitalsComponent } from './hospitals/hospitals.component';
import { SuperadminRoutingModule } from './superadmin-routing.module';
import { SuperadminComponent } from './superadmin.component';

@NgModule({
    imports: [
        CommonModule, SuperadminRoutingModule
    ],
    declarations: [HospitalsComponent, SuperadminComponent]
})
export class SuperadminModule {}


// WEBPACK FOOTER //
// ./src/app/modules/superadmin/superadmin.module.ts